import React, { Component } from "react";
import "./stylesheets/validate.css";
import HeaderBack from "../../../components/backoffice/headerback/HeaderBack";
import {
  getSiteDetails,
  getSiteDetailsThisco,
  getSubmitIncentive,
} from "../../../modules/serverCall";
import "react-datepicker/dist/react-datepicker.css";
import BootstrapTable from "react-bootstrap-table-next";
import Swal from "sweetalert2";
import moment from "moment";
import DatePicker from "react-datepicker";
import { Button } from "react-bootstrap";
import overlayFactory from "react-bootstrap-table2-overlay";
import Table from "react-bootstrap/Table";
import Spinner from "react-bootstrap/Spinner";

export default class Validate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      sitedetails: [],
      expanded: [0, 1],
      currnetmonthdata: moment(new Date()).subtract(1, "months"),
      loading: false,
      loadingData: "No data found",
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  handleInputFetch = (event) => {
    var loadingData = "No data Found";
    this.setState({
      loading: true,
      loadingData: "Loading",
    });
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);
    const userId = readData.userdata.user_id;
    const selectedTenant = localStorage.getItem("selected_tenant");
    const selectedTenantData = JSON.parse(selectedTenant);
    const currentMonthdata = this.state.currnetmonthdata;
    var sendData = {
      userId: userId,
      month_date: moment(currentMonthdata)
        .startOf("month")
        .format("YYYY-MM-DD"),
    };
    const fetchsitedetails = async () => {
      const responsesite =
        selectedTenantData.Tenant !== "Thisco"
          ? await getSiteDetails(sendData)
          : await getSiteDetailsThisco(sendData);
      const datarespsite = await responsesite;
      if (datarespsite.length > 0) {
      } else {
        loadingData = "No data found";
      }
      this.setState({
        sitedetails: responsesite,
        loading: false,
        loadingData: loadingData,
      });
    };
    fetchsitedetails();
  };

  // handleactionFormater = (cell, row, rowIndex) => {
  //   console.log('in');
  //   // if ((hoverIdx !== null || hoverIdx !== undefined) && hoverIdx === rowIndex) {
  //   //   return (
  //   //     <div
  //   //       style={ { width: '20px', height: '20px', backgroundColor: 'orange' } }
  //   //     />
  //   //   );
  //   // }
  // }

  dateFormatter = (event) => {
    return moment(event).format("MMM-YYYY");
  };

  handleSubmit = (event) => {
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);
    const userId = readData.userdata.user_id;
    var dateData = this.state.currnetmonthdata;
    var monthData = moment(event.MonthYear).format("MM");
    var year = moment(event.MonthYear).format("YYYY");
    var Status = 60;
    var siteEom = "SITEEOM";

    const permissionsdata = localStorage.getItem("permissions");
    const permissionsreadData = JSON.parse(permissionsdata);
    const filteredData = permissionsreadData.filter((obj) => {
      return (
        obj.PermissionCode === "VALIDATE_JOB" ||
        obj.PermissionCode === "AUTHORIZE_JOB"
      );
    });
    if (filteredData.length > 0) {
      if (filteredData[0].PermissionCode === "VALIDATE_JOB") {
        Status = 60;
      } else if (filteredData[0].PermissionCode === "AUTHORIZE_JOB") {
        Status = 90;
      }
    }
    var submitData = {
      SiteId: event.SiteID,
      Month: monthData,
      Year: year,
      Status: Status,
      ModifiedBy: userId,
      TypeOfEntry: siteEom,
    };

    const submitIncentive = async () => {
      const selectedTenant = localStorage.getItem("selected_tenant");
      const selectedTenantData = JSON.parse(selectedTenant);
      const responsesites = await getSubmitIncentive(submitData);
      var sendData = {
        userId: userId,
        month_date: moment(dateData).startOf("month").format("YYYY-MM-DD"),
      };
      const fetchsitedetails = async () => {
        const responsesite =
          selectedTenantData.Tenant !== "Thisco"
            ? await getSiteDetails(sendData)
            : await getSiteDetailsThisco(sendData);

        const datarespsite = await responsesite;
        this.setState({
          sitedetails: responsesite,
        });
      };
      fetchsitedetails();
    };
    var msg =
      "Once submitted, you will not be able to make any modifications. Are you sure you want to submit for the month?.";
    Swal.fire({
      title: "Are you sure?",
      text: msg,
      icon: "warning",
      showCancelButton: true,
      allowOutsideClick: false,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        submitIncentive();
      }
    });
  };

  handleInputChange = (event) => {
    this.setState({
      currnetmonthdata: event,
      sitedetails: [],
    });
  };

  render() {
    const selectedTenant = localStorage.getItem("selected_tenant");
    const selectedTenantData = JSON.parse(selectedTenant);

    var currnetMonth = new Date(this.state.currnetmonthdata);
    // const columns = [{
    //     dataField: 'MonthYear',
    //     text: 'Month',
    //     classes:"monthClm",
    //     headerClasses:'headerCls',
    //     formatter: this.dateFormatter,
    //   },{
    //     dataField: 'SiteName',
    //     text: 'Site Name',
    //     headerClasses:'headerCls',
    //   }, {
    //     dataField: 'Created',
    //     text: 'Created',
    //     headerClasses:'headerCls',
    //   }, {
    //     dataField: 'Rejected',
    //     text: 'Rejected',
    //     headerClasses:'headerCls',
    //   }, {
    //     dataField: 'OnHold',
    //     text: 'On-Hold',
    //     headerClasses:'headerCls',
    //   }, {
    //     dataField: 'Validated',
    //     headerClasses:'headerCls',
    //     text: 'Validated'
    //   }, {
    //     dataField: 'Authorized',
    //     headerClasses:'headerCls',
    //     text: 'Authorized'
    //   },{
    //     dataField: 'AllJobsValidated',
    //     headerClasses:'headerClsM',
    //     text: 'All Job Validated',
    //   },{
    //     dataField: 'AllJobsAuthorised',
    //     text: 'All Job Authorised',
    //     headerClasses:'headerClsM',
    //   }, {
    //     dataField: 'IncentiveType1',
    //     text: 'Incentive (Formula)',
    //     headerClasses:'headerClsM',
    //   },{
    //     dataField: 'IncentiveType2',
    //     text: 'Incentive (Entry)',
    //     headerClasses:'headerClsM',
    //   },{
    //     dataField: 'TLA',
    //     text: 'TLA',
    //     headerClasses:'headerClsM',
    //   },{
    //     dataField: 'UGA',
    //     text: 'UGA',
    //     headerClasses:'headerClsM',
    //   },{
    //     dataField: 'SPA',
    //     text: 'SPA',
    //     headerClasses:'headerClsM',
    //   },{
    //     dataField: 'SWA',
    //     text: 'SWA',
    //     headerClasses:'headerClsM',
    //   },{
    //     dataField: 'ValidationYN',
    //     text: 'Validation',
    //     headerClasses:'headerBtn',
    //     formatter: (cellContent, row) => {
    //       if (row.ValidationYN === 'Ready' && row.ValButton ==='Y') {
    //         return (
    //           <button type="button" className="btnvali btn btn-success font_size" onClick={() => {this.handleSubmit(row)}}> Ready</button>
    //         );
    //       }else{
    //         return row.ValidationYN
    //       }

    //     }
    //   }, {
    //     dataField: 'AuthorizationYN',
    //     text: 'Authorization',
    //     headerClasses:'headerBtn',
    //     formatter: (cellContent, row) => {
    //       if (row.AuthorizationYN === 'Ready' && row.AuthButton === 'Y') {
    //         return (
    //             <button type="button" className="btnvali btn btn-success font_size" onClick={() => {this.handleSubmit(row)}}> Ready</button>
    //         );
    //       }else{
    //         return row.AuthorizationYN
    //       }

    //     }
    //   }
    //   ,{
    //     text: 'Action',
    //     isDummyField: true,
    //     formatter: (cellContent, row) => {
    //       if (row.inStock) {
    //         return (
    //           <h5>
    //             <span className="label label-success"> Available</span>
    //           </h5>
    //         );
    //       }
    //       return (
    //         <button type="button" className="btnval btn btn-success font_size">
    //             Validate
    //           </button>
    //       );
    //     },
    //     events: {
    //       onClick: (e, column, columnIndex, row, rowIndex) => {
    //         this.handleactionFormater(row);
    //       },
    //     },
    //   }
    //   ];
    var products = this.state.sitedetails;
    var loadingData = this.state.loading;
    return (
      <div>
        <HeaderBack />
        <div className=" container jobfilter mb-4 mt-4">
          <div className="headerfilter-inct">
            <div className="viewcalander">
              <DatePicker
                selected={currnetMonth}
                onChange={(date) => this.handleInputChange(date)}
                dateFormat="MMM yyyy"
                showMonthYearPicker
                className="input-date-data-in outLine font_size"
              />
            </div>
            <div className="filterbtn">
              <Button
                variant="primary"
                className="font_size"
                onClick={this.handleInputFetch}
              >
                Fetch
              </Button>
            </div>
          </div>
        </div>
        <div className="newTabledata">
          {/* <div className="table-container-vali"> */}
          {/* <BootstrapTable
            classes="tabledata-vali"
            keyField="SiteID"
            id="tabledata"
            data={ products }
            columns={ columns }
            overlay={overlayFactory({
              spinner: true,
            })}
            loading={this.state.loading}
            noDataIndication={this.state.loadingData}
          /> */}
          {selectedTenantData.Tenant !== "Thisco" ? (
            <Table striped bordered responsive>
              <thead>
                <tr>
                  {/* <th rowSpan={2} className="headerCls">Month</th> */}
                  <th rowSpan={2} className="headerCls">
                    Site Name
                  </th>
                  <th rowSpan={2} className="headerCls">
                    Created
                  </th>
                  <th colSpan={11} className="headerClsM">
                    Branch
                  </th>
                  <th colSpan={11} className="headerClsHo">
                    Corporate Office
                  </th>
                </tr>
                <tr>
                  <th title="Rejected">Rej Jobs</th>
                  <th>On-Hold</th>
                  <th>Val Jobs</th>
                  <th>All Jobs Validated</th>
                  <th>Incentive (Formula)</th>
                  <th>Incentive (Entry)</th>
                  <th>TLA</th>
                  <th>UGA</th>
                  <th>SPA</th>
                  <th>SWA</th>
                  <th className="headerBtn">Validation</th>

                  <th title="Rejected">Rej Jobs</th>
                  <th>On-Hold</th>
                  <th>Auth Jobs</th>
                  <th>All Jobs Authorized</th>
                  <th>Incentive (Formula)</th>
                  <th>Incentive (Entry)</th>
                  <th>TLA</th>
                  <th>UGA</th>
                  <th>SPA</th>
                  <th>SWA</th>
                  <th className="headerBtn">Authorization</th>
                </tr>
              </thead>
              <tbody>
                {products.length > 0 ? (
                  products.map((item, indexdata) => {
                    return (
                      <tr key={indexdata}>
                        <td className="sitenameCls">{item.SiteName}</td>
                        <td>{item.Created}</td>
                        <td>{item.Rejected}</td>
                        <td>{item.OnHold}</td>
                        <td>{item.Validated}</td>
                        <td>
                          {item.AllJobsValidated === "Y" ? (
                            <span className="greenColor">
                              {item.AllJobsValidated}
                            </span>
                          ) : (
                            <span className="redColor">
                              {item.AllJobsValidated}
                            </span>
                          )}
                        </td>
                        <td>
                          {item.IncentiveType1 === "Y" ? (
                            <span className="greenColor">
                              {item.IncentiveType1}
                            </span>
                          ) : (
                            <span className="redColor">
                              {item.IncentiveType1}
                            </span>
                          )}
                        </td>
                        <td>
                          {item.IncentiveType2 === "Y" ? (
                            <span className="greenColor">
                              {item.IncentiveType2}
                            </span>
                          ) : (
                            <span className="redColor">
                              {item.IncentiveType2}
                            </span>
                          )}
                        </td>
                        <td>
                          {item.TLA === "Y" ? (
                            <span className="greenColor">{item.TLA}</span>
                          ) : (
                            <span className="redColor">{item.TLA}</span>
                          )}
                        </td>
                        <td>
                          {item.UGA === "Y" ? (
                            <span className="greenColor">{item.UGA}</span>
                          ) : (
                            <span className="redColor">{item.UGA}</span>
                          )}
                        </td>
                        <td>
                          {item.SPA === "Y" ? (
                            <span className="greenColor">{item.SPA}</span>
                          ) : (
                            <span className="redColor">{item.SPA}</span>
                          )}
                        </td>
                        <td>
                          {item.SWA === "Y" ? (
                            <span className="greenColor">{item.SWA}</span>
                          ) : (
                            <span className="redColor">{item.SWA}</span>
                          )}
                        </td>
                        <td>
                          {item.ValidationYN === "Ready" &&
                          item.ValButton === "Y" ? (
                            <button
                              type="button"
                              className="btnvali btn btn-success font_size"
                              onClick={() => {
                                this.handleSubmit(item);
                              }}
                            >
                              {" "}
                              Ready
                            </button>
                          ) : item.ValidationYN === "Done" ? (
                            <span className="greenColor">
                              {item.ValidationYN}
                            </span>
                          ) : (
                            <span className="redColor">
                              {item.ValidationYN}
                            </span>
                          )}
                        </td>
                        <td>{item.Rejected_70}</td>
                        <td>{item.OnHold_80}</td>
                        <td>{item.Authorized}</td>
                        <td>
                          {item.AllJobsAuthorised === "Y" ? (
                            <span className="greenColor">
                              {item.AllJobsAuthorised}
                            </span>
                          ) : (
                            <span className="redColor">
                              {item.AllJobsAuthorised}
                            </span>
                          )}
                        </td>
                        <td>
                          {item.IncentiveType1_90 === "Y" ? (
                            <span className="greenColor">
                              {item.IncentiveType1_90}
                            </span>
                          ) : (
                            <span className="redColor">
                              {item.IncentiveType1_90}
                            </span>
                          )}
                        </td>
                        <td>
                          {item.IncentiveType2_90 === "Y" ? (
                            <span className="greenColor">
                              {item.IncentiveType2_90}
                            </span>
                          ) : (
                            <span className="redColor">
                              {item.IncentiveType2_90}
                            </span>
                          )}
                        </td>
                        <td>
                          {item.TLA_90 === "Y" ? (
                            <span className="greenColor">{item.TLA_90}</span>
                          ) : (
                            <span className="redColor">{item.TLA_90}</span>
                          )}
                        </td>
                        <td>
                          {item.UGA_90 === "Y" ? (
                            <span className="greenColor">{item.UGA_90}</span>
                          ) : (
                            <span className="redColor">{item.UGA_90}</span>
                          )}
                        </td>
                        <td>
                          {item.SPA_90 === "Y" ? (
                            <span className="greenColor">{item.SPA_90}</span>
                          ) : (
                            <span className="redColor">{item.SPA_90}</span>
                          )}
                        </td>
                        <td>
                          {item.SWA_90 === "Y" ? (
                            <span className="greenColor">{item.SWA_90}</span>
                          ) : (
                            <span className="redColor">{item.SWA_90}</span>
                          )}
                        </td>
                        <td>
                          {item.AuthorizationYN === "Ready" &&
                          item.AuthButton === "Y" ? (
                            <button
                              type="button"
                              className="btnvali btn btn-success font_size"
                              onClick={() => {
                                this.handleSubmit(item);
                              }}
                            >
                              {" "}
                              Ready
                            </button>
                          ) : item.AuthorizationYN === "Done" ? (
                            <span className="greenColor">
                              {item.AuthorizationYN}
                            </span>
                          ) : (
                            <span className="redColor">
                              {item.AuthorizationYN}
                            </span>
                          )}
                        </td>
                      </tr>
                    );
                  })
                ) : loadingData === true ? (
                  <tr>
                    <td className="noData" colSpan={28}>
                      <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </Spinner>
                    </td>
                  </tr>
                ) : (
                  <tr>
                    <td className="noData" colSpan={28}>
                      no data found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          ) : (
            <Table striped bordered responsive>
              <thead>
                <tr>
                  {/* <th rowSpan={2} className="headerCls">Month</th> */}
                  <th rowSpan={2} className="headerCls">
                    Site Name
                  </th>
                  <th rowSpan={2} className="headerCls">
                    Created
                  </th>
                  <th colSpan={6} className="headerClsM">
                    Branch
                  </th>
                  <th colSpan={6} className="headerClsHo">
                    HO
                  </th>
                </tr>
                <tr>
                  <th title="Rejected">Rej Jobs</th>
                  <th>On-Hold</th>
                  <th>Val Jobs</th>
                  <th>All Jobs Validated</th>
                  <th>OT</th>
                  <th className="headerBtn">Validation</th>

                  <th title="Rejected">Rej Jobs</th>
                  <th>On-Hold</th>
                  <th>Auth Jobs</th>
                  <th>All Jobs Authorized</th>
                  <th>OT</th>
                  <th className="headerBtn">Authorization</th>
                </tr>
              </thead>
              <tbody>
                {products.length > 0 ? (
                  products.map((item, indexdata) => {
                    return (
                      <tr key={indexdata}>
                        <td className="sitenameCls">{item.SiteName}</td>
                        <td>{item.Created}</td>
                        <td>{item.Rejected}</td>
                        <td>{item.OnHold}</td>
                        <td>{item.Validated}</td>
                        <td>
                          {item.AllJobsValidated === "Y" ? (
                            <span className="greenColor">
                              {item.AllJobsValidated}
                            </span>
                          ) : (
                            <span className="redColor">
                              {item.AllJobsValidated}
                            </span>
                          )}
                        </td>

                        <td>
                          {item.OT_60 === "Y" ? (
                            <span className="greenColor">{item.OT_60}</span>
                          ) : (
                            <span className="redColor">{item.OT_60}</span>
                          )}
                        </td>
                        <td>
                          {item.ValidationYN === "Ready" &&
                          item.ValButton === "Y" ? (
                            <button
                              type="button"
                              className="btnvali btn btn-success font_size"
                              onClick={() => {
                                this.handleSubmit(item);
                              }}
                            >
                              {" "}
                              Ready
                            </button>
                          ) : item.ValidationYN === "Done" ? (
                            <span className="greenColor">
                              {item.ValidationYN}
                            </span>
                          ) : (
                            <span className="redColor">
                              {item.ValidationYN}
                            </span>
                          )}
                        </td>
                        <td>{item.Rejected_70}</td>
                        <td>{item.OnHold_80}</td>
                        <td>{item.Authorized}</td>
                        <td>
                          {item.AllJobsAuthorised === "Y" ? (
                            <span className="greenColor">
                              {item.AllJobsAuthorised}
                            </span>
                          ) : (
                            <span className="redColor">
                              {item.AllJobsAuthorised}
                            </span>
                          )}
                        </td>

                        <td>
                          {item.OT_90 === "Y" ? (
                            <span className="greenColor">{item.OT_90}</span>
                          ) : (
                            <span className="redColor">{item.OT_90}</span>
                          )}
                        </td>
                        <td>
                          {item.AuthorizationYN === "Ready" &&
                          item.AuthButton === "Y" ? (
                            <button
                              type="button"
                              className="btnvali btn btn-success font_size"
                              onClick={() => {
                                this.handleSubmit(item);
                              }}
                            >
                              {" "}
                              Ready
                            </button>
                          ) : item.AuthorizationYN === "Done" ? (
                            <span className="greenColor">
                              {item.AuthorizationYN}
                            </span>
                          ) : (
                            <span className="redColor">
                              {item.AuthorizationYN}
                            </span>
                          )}
                        </td>
                      </tr>
                    );
                  })
                ) : loadingData === true ? (
                  <tr>
                    <td className="noData" colSpan={28}>
                      <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </Spinner>
                    </td>
                  </tr>
                ) : (
                  <tr>
                    <td className="noData" colSpan={28}>
                      no data found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
        </div>
      </div>
    );
  }
}
